export default __webpack_public_path__ + "static/media/noChatLight.6cc48a1e.jpg";